"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagMD = function FlagMD(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M80.07-122H209.54a7.06,7.06,0,0,1,7.06,7.06V139.3a7.06,7.06,0,0,1-7.06,7.06H80.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "137.53",
    y: "1",
    width: "136.53",
    height: "268.36",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-185.94-122H-56.47V146.36H-185.94A7.06,7.06,0,0,1-193,139.3V-114.94a7.06,7.06,0,0,1,7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.34,57.71l-3.52,2.87L20.82,41l3.51-2.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M33.12,45.3l-7,5.72-7-8.64,7-5.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.23,38.08,4.75,41l-16,19.63-3.51-2.87Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-.53,36.66l7,5.72L-.54,51l-7-5.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.11,45.45-4.22,68.11,11.64,79.44V47.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.18,45.45,27.51,68.11,11.64,79.44V47.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-20.08,45.45V-13.47h6.8V31.85c0,6.8-6.8,13.6-6.8,13.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-24.61,56.78V-13.47h6.79V43.18c0,6.8-6.79,13.6-6.79,13.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-29.15,65.84V-13.47h6.8V52.25c0,6.79-6.8,13.59-6.8,13.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.28-11.21V31.85c0,11.33,16.42,9.82,24.92,18.13,8.5-8.31,24.93-6.8,24.93-18.13V-11.21Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.28,13.72V31.85c0,11.33,16.42,9.82,24.92,18.13,8.5-8.31,24.93-6.8,24.93-18.13V13.72Zm0,0",
    transform: "translate(194 123)",
    fill: "#41479b"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.64,43.18l-6.8-4.53V36.38l2.27-2.26V20.52L.31,16l6.8-9.07H9.38l2.26,2.27,2.27-2.27h2.27L23,16l-6.8,4.53v13.6l2.26,2.26v2.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.58-8.94S-6.48-6.67-6.48,2.39,2.58,16,2.58,16l4.53-6.8C-6.48,4.66,2.58-8.94,2.58-8.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.71-8.94s9.06,2.27,9.06,11.33S20.71,16,20.71,16l-4.53-6.8C29.77,4.66,20.71-8.94,20.71-8.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-11,13.72-6.48,16l4.53-2.27-4.53-2.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.24,13.72,29.77,16l4.53-2.27-4.53-2.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.64-7.8l1.65,1.68,2.36,0,0,2.36,1.69,1.65L15.62-.49l0,2.35-2.36,0L11.64,3.52,10,1.84l-2.36,0,0-2.35L6-2.14,7.67-3.79l0-2.36,2.36,0Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-3.75,23.62l1.64,1.82,2.27-.9a1.34,1.34,0,0,1,1.65,1.91L.59,28.56l1.55,1.89A1.33,1.33,0,0,1,.84,32.6l-2.4-.51-1.3,2.07a1.34,1.34,0,0,1-2.46-.58l-.25-2.43-2.37-.61A1.33,1.33,0,0,1-8.15,28l2.23-1-.15-2.44a1.33,1.33,0,0,1,2.32-1Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.44,28.79a5.82,5.82,0,0,1,5.1-4.68,6.11,6.11,0,0,0-1.64-.62A5.86,5.86,0,1,0,27.67,35a5.79,5.79,0,0,0,1.76,0,5.83,5.83,0,0,1-3-6.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.58-11.21,7.11-33.87l-9.06-6.79L.31-42.93H4.84a9.93,9.93,0,0,1,6.8-2.27c4.54,0,9.07,2.27,9.07,9.07S23-11.21,23-11.21Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-13.28-20.27a9.07,9.07,0,0,0-9.07,9.06H-4.22a9.06,9.06,0,0,0-9.06-9.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffaa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-15.55-11.21h-13.6V-26.29a5.31,5.31,0,0,1,5.31-5.31h3a5.31,5.31,0,0,1,5.31,5.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.37,45.45V-13.47h-6.8V31.85c0,6.8,6.8,13.6,6.8,13.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M47.9,56.78V-13.47H41.1V43.18c0,6.8,6.8,13.6,6.8,13.6Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.43,65.84V-13.47H45.64V52.25c0,6.79,6.79,13.59,6.79,13.59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M36.57-20.27a9.07,9.07,0,0,1,9.07,9.06H27.51a9.06,9.06,0,0,1,9.06-9.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffaa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M38.84-11.21H52.43V-26.29a5.31,5.31,0,0,0-5.31-5.31h-3a5.31,5.31,0,0,0-5.31,5.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffbe5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M62.18,12.84l2.9,1.77L33.34,66.72,30.44,65Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffaa5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.06,56.64,37.4,63.72l-5.53-4.43,5.66-7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M61.17,12.25,66,15.2l-6.8,11.16-4.84-2.94Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-37.6,15.42l32,49.48-1.9,1.23-32-49.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-17.47,38.89A6.89,6.89,0,0,0-19,42.82a6.75,6.75,0,0,0-3.6-2,6.84,6.84,0,0,0,.39,4.11,6.83,6.83,0,0,0-4.19-.25,7.69,7.69,0,0,0,3.77,4.73,7.75,7.75,0,0,0,6,1.08l.46-.31a7.67,7.67,0,0,0,1.46-5.87,7.7,7.7,0,0,0-2.76-5.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-14.13,50.3a2.27,2.27,0,0,1-2.27,2.27,2.27,2.27,0,0,1-2.27-2.27A2.27,2.27,0,0,1-16.4,48a2.27,2.27,0,0,1,2.27,2.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-26.08,25.57a6.82,6.82,0,0,0-1.49,3.93,6.8,6.8,0,0,0-3.59-2,6.75,6.75,0,0,0,.38,4.11,6.86,6.86,0,0,0-4.2-.25A7.67,7.67,0,0,0-31.2,36a7.64,7.64,0,0,0,5.95,1.08l.47-.3A7.72,7.72,0,0,0-23.32,31a7.71,7.71,0,0,0-2.76-5.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-22.74,37A2.27,2.27,0,0,1-25,39.25,2.27,2.27,0,0,1-27.27,37,2.27,2.27,0,0,1-25,34.71,2.27,2.27,0,0,1-22.74,37Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-34.69,12.25a6.86,6.86,0,0,0-1.49,3.93,6.79,6.79,0,0,0-3.6-2,6.83,6.83,0,0,0,.38,4.11A6.82,6.82,0,0,0-43.59,18a7.69,7.69,0,0,0,3.78,4.72,7.7,7.7,0,0,0,6,1.08l.46-.3a7.72,7.72,0,0,0,1.46-5.87,7.71,7.71,0,0,0-2.76-5.38Zm0,0",
    transform: "translate(194 123)",
    fill: "#73af00"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-31.36,23.66a2.27,2.27,0,0,1-2.26,2.27,2.27,2.27,0,0,1-2.27-2.27,2.27,2.27,0,0,1,2.27-2.27,2.27,2.27,0,0,1,2.26,2.27Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff4b55"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-12,52.22l5.65,7.08-5.53,4.43-5.66-7.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "192.05",
    y: "73.27",
    width: "2.27",
    height: "15.86",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "189.78",
    y: "75.54",
    width: "6.8",
    height: "2.27",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-1.95-40.66l6.79,5.09v-7.36H.31Zm0,0",
    transform: "translate(194 123)",
    fill: "#ff875a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.31-49.73v2.27H2.58v2.26H.31v2.27H4.84a9.93,9.93,0,0,1,6.8-2.27c4.54,0,9.07,2.27,9.07,9.07S23-11.21,23-11.21h4.54a9.06,9.06,0,0,1,9.06-9.06,9,9,0,0,1,2.27.32V-24.8a6.79,6.79,0,0,1,6.8-6.8,6.79,6.79,0,0,1,6.79,6.8V28.82L55.36,24l-1-.59,6.8-11.17,1,.59,1.45.88L66,15.2l-6.8,11.17-1-.59-5.84,9.58V65.85S47,60.42,45.86,54.42a30.2,30.2,0,0,1-2.62-4l-2.59,4.26,2.41,1.92L37.4,63.73l-1.5-1.21-2.56,4.21L30.43,65l2.79-4.59L31.87,59.3l1.92-2.41L27.85,49.6,26.09,51,20.8,44.54a42.92,42.92,0,0,0-4.13,1.9L27.5,68.11,11.64,79.45-4.22,68.11,6.61,46.44C5.82,46,5,45.61,4.17,45.24L-.54,51-2.3,49.6l-5.95,7.29,1.93,2.41-1.92,1.54,2.63,4.07-1.91,1.23L-10,62.26l-1.83,1.46-5.66-7.08,2.54-2-1.35-2.09h-.09a2.22,2.22,0,0,1-1.9-1,2.44,2.44,0,0,1-.33-.91,7.81,7.81,0,0,1-1.31-.19,29.68,29.68,0,0,1-2.63,4c-1.16,6-6.57,11.43-6.57,11.43V36.94A9.42,9.42,0,0,1-31.2,36,7.67,7.67,0,0,1-35,31.32a5.23,5.23,0,0,1,1.57-.22,8.16,8.16,0,0,1,2.62.47,8.32,8.32,0,0,1-.52-2.24l-2.23-3.45h-.09a2.21,2.21,0,0,1-1.9-1,2.18,2.18,0,0,1-.33-.91,8.58,8.58,0,0,1-4-1.25A7.67,7.67,0,0,1-43.59,18,5.23,5.23,0,0,1-42,17.78a7.9,7.9,0,0,1,2.62.47,6.83,6.83,0,0,1-.38-4.11,6.82,6.82,0,0,1,3.6,2,6.81,6.81,0,0,1,1.48-3.93,7.68,7.68,0,0,1,2.76,5.38,8.71,8.71,0,0,1-.48,4.12,2.2,2.2,0,0,1,.69.67,2.23,2.23,0,0,1,.09,2.23l2.23,3.45a1.83,1.83,0,0,1,.26.16V-24.8a6.8,6.8,0,0,1,6.8-6.8,6.81,6.81,0,0,1,6.8,6.8v4.85a8.94,8.94,0,0,1,2.26-.32A9.07,9.07,0,0,1-4.22-11.2H2.57L7.1-33.87.31-39v5.1H-2V-45.2H-4.22v-2.26H-2v-2.27H.32m36.37,103,.84-1.05.44.35,3.65-6a12.67,12.67,0,0,1-.52-3.39v-.39c-2-2.61-4.53-6.77-4.53-10.94,0,4.77-2.93,7.26-6.94,9.17l3.49,4.28-1.76,1.43,5.33,6.54m-49.87-.09,1.21-1,.83,1,5.33-6.53L-7.57,45.3l2.89-3.54c-4.84-2-8.61-4.5-8.61-9.91a16.84,16.84,0,0,1-2.85,8.49,8.82,8.82,0,0,1,1.43,3.93,8.71,8.71,0,0,1-.49,4.12,2.24,2.24,0,0,1,.7.67,2.25,2.25,0,0,1,.09,2.23l1.23,1.89M.31-51.43H-1.95a1.7,1.7,0,0,0-1.7,1.7v.57h-.57a1.7,1.7,0,0,0-1.7,1.7v2.26a1.7,1.7,0,0,0,1.7,1.7h.57v9.63a1.7,1.7,0,0,0,1.7,1.7H.31A1.7,1.7,0,0,0,2-33.87v-1.7l1.81,1.36,1.41,1.06L1.18-12.91H-2.66A10.78,10.78,0,0,0-13.29-22l-.56,0V-24.8a8.51,8.51,0,0,0-8.5-8.5,8.51,8.51,0,0,0-8.5,8.5V14.86a8.3,8.3,0,0,0-2.86-4,1.65,1.65,0,0,0-1-.32,1.68,1.68,0,0,0-1.27.58,7.26,7.26,0,0,0-1.27,2.13,7.24,7.24,0,0,0-2.27-.79,1.24,1.24,0,0,0-.27,0,1.7,1.7,0,0,0-1.64,1.26,7.22,7.22,0,0,0-.2,2.39H-42a6.91,6.91,0,0,0-2.07.3,1.7,1.7,0,0,0-1.17,1.95,9.38,9.38,0,0,0,4.58,5.86,11,11,0,0,0,3.56,1.35c0,.09.1.18.16.27a3.91,3.91,0,0,0,2.44,1.68l1.23,1.91h-.12a6.91,6.91,0,0,0-2.07.3,1.71,1.71,0,0,0-1.17,1.95,9.38,9.38,0,0,0,4.58,5.86,9.3,9.3,0,0,0,1.22.62V65.84a1.7,1.7,0,0,0,1.05,1.57,1.64,1.64,0,0,0,.65.13,1.66,1.66,0,0,0,1.2-.5c.24-.23,5.57-5.63,7-11.9.57-.75,1.09-1.51,1.58-2.27a3.85,3.85,0,0,0,2.11,1.25l.07.11-1.34,1.08a1.7,1.7,0,0,0-.63,1.14,1.73,1.73,0,0,0,.36,1.25l5.66,7.08a1.73,1.73,0,0,0,1.14.63h.19A1.63,1.63,0,0,0-10.79,65l.36-.29,1.49,2.3a1.67,1.67,0,0,0,1.07.74,1.47,1.47,0,0,0,.36,0,1.68,1.68,0,0,0,.92-.27l1.1-.71-.25.49a1.71,1.71,0,0,0,.53,2.15L10.66,80.82a1.68,1.68,0,0,0,2,0L28.5,69.49A1.71,1.71,0,0,0,29,67.34L19,47.19c.43-.2.87-.4,1.34-.6l4.49,5.5a1.69,1.69,0,0,0,1.32.63,1.75,1.75,0,0,0,1.07-.38l.44-.36,4,4.91-1.07,1.34a1.7,1.7,0,0,0,.27,2.39l.19.15-2,3.3a1.72,1.72,0,0,0,.57,2.34l2.91,1.76a1.61,1.61,0,0,0,.88.25,1.33,1.33,0,0,0,.4,0,1.67,1.67,0,0,0,1-.76l1.56-2.56a1.72,1.72,0,0,0,1.06.36,1.66,1.66,0,0,0,1.32-.64l5.66-7.07a1.69,1.69,0,0,0,.36-.88A30.28,30.28,0,0,0,51.23,67a1.75,1.75,0,0,0,1.21.5,1.64,1.64,0,0,0,.65-.13,1.71,1.71,0,0,0,1-1.57v-30L58.89,28a1.32,1.32,0,0,0,.34,0,1.7,1.7,0,0,0,1.46-.82l6.8-11.17a1.73,1.73,0,0,0,.2-1.28,1.77,1.77,0,0,0-.77-1.06L64.5,12.26l-1.45-.88-1-.59a1.69,1.69,0,0,0-2.33.57l-5.61,9.21V-24.8a8.51,8.51,0,0,0-8.5-8.5,8.51,8.51,0,0,0-8.5,8.5v2.85l-.57,0a10.79,10.79,0,0,0-10.63,9.06H24.48c-.53-4.46-2.07-17.73-2.07-23.23,0-7.93-5.56-10.76-10.76-10.76a12.28,12.28,0,0,0-7.41,2.27h0a1.79,1.79,0,0,0,.09-.57v-2.26a1.69,1.69,0,0,0-1.7-1.7H2v-.57a1.71,1.71,0,0,0-1.71-1.7ZM-14.16,40.34A24.09,24.09,0,0,0-13,38.07,15.23,15.23,0,0,0-7.4,42.4l-1.48,1.83a1.68,1.68,0,0,0-.38,1.24,1.74,1.74,0,0,0,.62,1.15l.44.35-3,3.72a1.51,1.51,0,0,0-.56-.16H-12a1.63,1.63,0,0,0-.5.07,3.94,3.94,0,0,0-.6-2.45,2.48,2.48,0,0,0-.19-.26,10.5,10.5,0,0,0,.24-3.8,10.79,10.79,0,0,0-1.14-3.74Zm46.42,1.22a13.25,13.25,0,0,0,4.06-3.47,26.91,26.91,0,0,0,3.09,5.26,13,13,0,0,0,.39,2.95l-2.58,4.24a1.76,1.76,0,0,0-.44.15l-3-3.72.44-.35a1.74,1.74,0,0,0,.62-1.15,1.68,1.68,0,0,0-.38-1.24ZM-.54,52.72A1.71,1.71,0,0,0,.78,52.1l2.86-3.52L-4.11,64.1-4.18,64-6,61.2l.73-.58a1.7,1.7,0,0,0,.63-1.14A1.73,1.73,0,0,0-5,58.23l-1.08-1.34L-2,52l.44.36a1.65,1.65,0,0,0,1.07.38Zm43.42,1.6.37-.61c.32.48.67.95,1,1.43,0,.15.06.29.1.43a2.13,2.13,0,0,0-.26-.26Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffaa5a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagMD;
exports["default"] = _default;